import axios from "axios"

export const getPaymentChannel = async () => {
  const finalUrl =
      window._HOST + "participant/payment-channel"

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const getPaymentInstructions = async (idTransaksi) => {
  const finalUrl =
      window._HOST + "participant/payment-instruction/" + idTransaksi

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const getTransactions = async () => {
  const finalUrl =
      window._HOST + "participant/transaction"

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const createTransaction = async (payload) => {
  const finalUrl =
      window._HOST + "participant/transaction"

  const response =
      await axios.post(finalUrl, payload)

  return response.data
}

export const getOfferedPaymentMechanism = async () => {

  const finalUrl =
      window._HOST + "public/offered-payment"

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const getOfferedBank = async () => {

  const finalUrl =
      window._HOST + "participant/offered-bank-transfer"

  const response =
      await axios.get(finalUrl)

  return response.data
}

export const uploadTransferReceipt = async (file) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    },
    withCredentials: true
  }

  const formData = new FormData()
  formData.append('photo', file)

  const response =
    await axios.post(
      window._HOST + 'participant/transfer-receipt',
      formData,
      config
    )

  return response.data
}

export const getUnverifiedTransferReceipt = async () => {

  const finalUrl =
      window._HOST + "participant/transfer-receipt"

  const response =
      await axios.get(finalUrl)

  return response.data
}